module.exports = __webpack_public_path__ + "img/video-camera-off.7e494360.svg";